<script>
    import SMProviderObject from '@/components/page-smart-filter/SMProviderObject.vue';
    import SMGameObject from '@/components/page-smart-filter/SMGameObject.vue';

    export default {
        data() {
            return {
                providerID: null,
                gameID: null,
            }
        },
        props: {
            data: Object,
            pushData: Function,
            spliceData: Function, 
        },
        computed: {
            providers() {return this.$store.getters.PROVIDERS},
            games() {return this.$store.getters.GAME_BY_PROVIDERS(this.data.providers)},
        },
        components: {
            SMProviderObject: SMProviderObject,
            SMGameObject: SMGameObject
        },
        methods: {
            async spliceObject(event, fieldName) {
                this.spliceData(event, fieldName);
            },
            async selectProvider() {
                this.gameID = null;
            }
        }
    }
</script>

<template>
    <div class="left_sub_panel_data">
        <label>Provider:</label>
        <div class="left_sub_multi_container mt_5 mb_10">
            <select
                class="right_input"
                v-model="providerID"
                @change="selectProvider()"
            >
                <option 
                    :value="null"
                >None</option>
                <option
                    v-for="(providerValue, providerIndex) in providers" :key="providerIndex"
                    :value="providerValue['id']"
                >{{ providerValue['name'] }}</option>
            </select>
            <button
                @click="pushData(providerID, 'providers')"
                :disabled="providerID == null"
                class="button_blue_100 ml_10"
            >Add</button>
        </div>

        <label
            class="mb_5"
            v-if="data['providers'].length !== 0"
        >Select Provider:</label>
        <div 
            class="left_sub_multi_container mb_5"
            v-for="(providerValue, providerIndex) in data['providers']" :key="providerIndex"   
        >
            <SMProviderObject 
                :providerID="providerValue"
                @calldelete="spliceObject($event, 'providers')"
            />
        </div>
        

        <label
            class="mt_5"
        >Game:</label>
        <div class="left_sub_multi_container mt_5">
            <select
                class="right_input"
                v-model="gameID"
            >
                <option 
                    :value="null"
                >None</option>
                <option
                    v-for="(gameValue, gameIndex) in games" :key="gameIndex"
                    :value="gameValue['id']"
                >{{ gameValue['name'] }}</option>
            </select>
            <button
                @click="pushData(gameID, 'games')"
                :disabled="gameID == null"
                class="button_blue_100 ml_10"
            >Add</button>
        </div>

        <label
            class="mb_5 mt_10"
            v-if="data['games'].length !== 0"
        >Select Game:</label>
        <div 
            class="left_sub_multi_container mb_5"
            v-for="(gameValue, gameIndex) in data['games']" :key="gameIndex"   
        >
            <SMGameObject 
                :gameID="gameValue"
                @calldelete="spliceObject($event, 'games')"
            />
        </div>
    </div>
</template>